var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomRedirectIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 87,
    viewBox: "0 0 70 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2053 2.28726L26.0459 0.432617L0.678808 71.001L5.83822 72.8556L31.2053 2.28726Z",
    fill: "#5B5B5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.323 15.9894L64.1636 14.1348L38.7965 84.7031L43.9559 86.5578L69.323 15.9894Z",
    fill: "#5B5B5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9474 86.5657L45.8115 81.3799L2.5344 65.8231L0.670265 71.0089L43.9474 86.5657Z",
    fill: "#5B5B5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1518 14.129L34.769 9.42383L56.81 17.3469L53.5812 20.7538L35.1518 14.129Z",
    fill: "#5B5B5B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.465 21.178L69.3291 15.9922L26.052 0.435427L24.1878 5.62123L67.465 21.178Z",
    fill: "#5B5B5B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomRedirectIcon);
export default __webpack_public_path__ + "static/media/customRedirectIcon.f90745d2e467e907c768efae3f12ba93.svg";
export { ForwardRef as ReactComponent };